import { Stack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { ButtonSkeleton, InputSkeleton, TextSkeleton } from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import { directTreasurySellConstants } from '../constants';

export const ListLoadingItemDesktop: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const getFlex = (index: number) => {
    const currentHead = directTreasurySellConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="80px">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <Stack pr={Spacing['inline.xxxs']}>
          <InputSkeleton />
        </Stack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TextSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <ButtonSkeleton />
      </TableContentItemColumn>
    </TableContent>
  );
};
